import type { DepositColumns, DepositSort } from '@library/types/payments';
import { Button } from '@library/components/buttons';
import { DEPOSITS_HEADER_INFO } from '@bo-constants/payments';
import { SortIndicator } from '@library/components/SortIndicator';
import { classNames } from '@library/utils';
import { getSortDirection } from '@library/component-utils/table';

export interface DepositsHeaderProps {
  handleSort: (sort: DepositSort) => void;
  sort: DepositSort;
}

export const DepositsHeader = ({ handleSort, sort }: DepositsHeaderProps) => (
  <thead className="bg-soFresh-110 text-soClean-130 text-2xs h-14 whitespace-nowrap py-3 font-bold xl:text-xs">
    <tr>
      {DEPOSITS_HEADER_INFO.map(
        ({ column, essential, label, shortenedLabel, sortEnabled }) => (
          <th
            key={label}
            className={classNames(
              column === 'paymentId' ? 'hidden md:table-cell' : '',
              'items-center text-left first-of-type:pl-2 xl:pl-2'
            )}
          >
            <Button
              className="grid grid-cols-[1fr_1rem] items-center text-left xl:grid-cols-[1fr_1.25rem]"
              disabled={!sortEnabled}
              onClick={() => {
                const newSortDirection = getSortDirection<DepositColumns>({
                  column,
                  sort
                });

                handleSort({
                  sortBy: column,
                  sortDirection: newSortDirection
                });
              }}
            >
              <span className="hidden lg:inline xl:pr-2">{label}</span>
              {essential && (
                <span className="inline lg:hidden">
                  {shortenedLabel ?? label}
                </span>
              )}
              {sortEnabled && (
                <div className="flex flex-col items-center justify-around xl:pr-1">
                  <SortIndicator column={column} sort={sort} />
                </div>
              )}
            </Button>
          </th>
        )
      )}
    </tr>
  </thead>
);
